import styled from 'styled-components';

export const StyledHeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 100px;
    padding: 1rem 3rem;
    background-color: #22371b;
    box-sizing: border-box;

    @media (max-width: 900px) {
        justify-content: center;
    }
`